// extracted by mini-css-extract-plugin
module.exports = {"container":"SidebarTabLocalization_container__1Z8QI"};